export const OBJECTS = {
  ru: "Подразделения",
  en: "Objects"
};
export const MODELS = {
  ru: "Модели оценки",
  en: "Valuation Models"
}
export const SELECT = {
  ru: "Выбрать",
  en: "Select"
}

export const CHECKLIST = {
  ru: "Чек-лист",
  en: "Checklist"
}